<script>
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js";
import {watch} from "vue";
import {useTaskModelStore} from "@/stores/Boarding/TaskModel.js";
import TaskModelFilter from "@/views/Boarding/TaskModel/Components/TaskModelFilter.vue";
import axios from "axios";

export default {
    components: {TaskModelFilter},
    setup() {
        const {
            loading,
            total,
            filter,
        } = useSharedData();

        const {transformFilterValues} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const taskStore = useTaskModelStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0px"
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                value: "code",
                sortable: true,
                width: "0px"
            },
            {
                text: $i18n.t("common.name"),
                align: "left",
                value: "name",
                sortable: true,
            },
            {
                text: $i18n.t("common.comment"),
                align: "left",
                value: "description",
                sortable: true,
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_BOARDING_TASK'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'boarding_task_models.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['DELETE_BOARDING_TASK'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'boarding_task_models.delete', params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/boardingTaskModels', {params: transformFilterValues(filter.value)}).then((response) => {
                taskStore.setTaskModels(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "boarding_task_models.view", params: {id: item.id}});
        }

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});

        return {
            taskStore,
            securityStore,
            headers,
            actions,
            loading,
            total,
            filter,
            findAll,
            view,
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.task_model')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['SAVE_BOARDING_TASK']"
                    @press="$router.push({name: 'boarding_task_models.add'})"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <TaskModelFilter :filter="filter"/>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="taskStore.taskModels"
                    :loading="loading"
                    sort-by="name"
                    dense
                    @rowDbClick:row="view"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>